module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_c('span', {
    staticClass: "logo-mini header_logo"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "appdestopview",
    attrs: {
      "src": "/static/img/applogo.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "mobileview",
    attrs: {
      "src": "/static/img/applogomob.png"
    }
  })])])], 1), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top flex",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu custom_menu_wrp"
  }, [(this.adminCheck == 'superAdmin') ? _c('multiselect', {
    staticClass: "multiSelectMargin",
    attrs: {
      "track-by": "value",
      "searchable": "true",
      "label": "name",
      "options": _vm.cityList,
      "selectLabel": "",
      "deselectLabel": "",
      "selectedLabel": "",
      "showLabels": "true",
      "allow-empty": false
    },
    on: {
      "select": _vm.onCitySelect
    },
    model: {
      value: (_vm.$store.state.auth.cityId),
      callback: function($$v) {
        _vm.$set(_vm.$store.state.auth, "cityId", $$v)
      },
      expression: "$store.state.auth.cityId"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.user.role.key == 'superAdmin') ? _c('button', {
    staticClass: "btn gradientbt1 gradientbt syncWithTraccar",
    on: {
      "click": _vm.syncWithTraccar
    }
  }, [_vm._v("\n        Sync With Traccar\n      ")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navW",
    staticStyle: {
      "float": "right"
    }
  }, [_c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('b', [_vm._v("\n                " + _vm._s(_vm.user.role.key == "superAdmin" ? null : _vm.user.cityId.cityName) + "\n              ")])]), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName))])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu header_dropdown"
  }, [_c('li', {
    staticClass: "user-header"
  }, [_c('p', [_vm._v("\n                " + _vm._s(_vm.user.firstName) + " " + _vm._s(_vm.user.lastName) + " - " + _vm._s(_vm.user.roleName) + "\n                "), _c('small', [_vm._v("Member since\n                  " + _vm._s(_vm._f("moment")(_vm.user.createdAt, "MMMM, YYYY")))])])]), _vm._v(" "), _c('div', {
    staticClass: "user_footer_wrp"
  }, [_c('li', {
    staticClass: "user-footer",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Profile")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Log out")])])])])])])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticStyle: {
      "width": "16%"
    }
  }, [_c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "push-menu",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "logo-mini col-xs-8 wastea_main_heading",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('b', [_c('h2', {
    staticClass: "logo1",
    staticStyle: {
      "margin-bottom": "12px",
      "font-size": "22px",
      "color": "#35A2FE",
      "font-weight": "900",
      "margin-top": "12px",
      "margin-left": "65px"
    }
  }, [_vm._v("\n          WASTE MANAGEMENT SYSTEM\n        ")])]), _vm._v(" "), _c('h2', {
    staticClass: "logo3",
    staticStyle: {
      "margin-bottom": "1px",
      "font-size": "22px",
      "color": "#35A2FE",
      "font-weight": "900",
      "margin-top": "13px"
    }
  }, [_vm._v("\n        WASTE MANAGEMENT SYSTEM\n      ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1579f866"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/main/MainHeader.vue
// module id = 2276
// module chunks = 1